import { useCallback, useEffect, useState } from "react"

import { disconnectMcp, getMcpConnections } from "../../User/services"

// Loads the MCP clients the current user is connected to and exposes a disconnect
// action. Returns a Set of connected card keys so the grid can mark cards as
// connected (mirrors how the Integrations page uses `is_connected`).
export const useMcpConnections = () => {
  const [connectedKeys, setConnectedKeys] = useState(() => new Set())
  const [loading, setLoading] = useState(true)
  const [disconnectingKey, setDisconnectingKey] = useState(null)

  const fetchConnections = useCallback(async () => {
    setLoading(true)

    const res = await getMcpConnections()

    if (res.ok && Array.isArray(res.data?.connections)) {
      setConnectedKeys(new Set(res.data.connections.map((item) => item.key)))
    }

    setLoading(false)
  }, [])

  useEffect(() => {
    fetchConnections()
  }, [fetchConnections])

  const disconnect = useCallback(async (key) => {
    setDisconnectingKey(key)

    const res = await disconnectMcp(key)

    if (res.ok) {
      setConnectedKeys((prev) => {
        const next = new Set(prev)
        next.delete(key)
        return next
      })
    }

    setDisconnectingKey(null)
  }, [])

  return { connectedKeys, loading, disconnectingKey, disconnect, refetch: fetchConnections }
}
